import { Link } from "react-router-dom";

function MenuInteremedioAcerca() {
  return (
    <div style={styles.container}>
      <div style={styles.innerContainer}>
        <Link style={styles.boton} to="/historia">Historia</Link>
        <Link style={styles.boton} to="/mision">Misión</Link>
        <Link style={styles.boton} to="/horariosSedes">Sedes</Link>
        <Link style={styles.boton} to="/exalumnos">ExAlumnos</Link>
        <Link style={styles.boton} to="/horariosSedes">Horarios</Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    overflowX: 'auto',
    width: '100%',
    backgroundColor: '#f7f3e9',
  },
  innerContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '1rem',
    padding: '0.5rem',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  boton: {
    padding: '0.6rem 1.2rem',
    backgroundColor: 'transparent',
    color: '#294235',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
  },
};

export default MenuInteremedioAcerca;
